import USE_MERCURE from '~/const/mercure';
import { CATEGORY_INFIX, EDITO_INFIX, PRODUCT_INFIX, STATIC_INFIX, SEARCH_INFIX } from '~/const/infix';

var buildHomeUrl = locale => "/".concat(locale.market, "/").concat(locale.language);

var CgvType = {
  PRO: 'cgv-pro',
  DEFAULT: 'cgv'
};
var CguType = {
  PRO: 'cgu-acheteurs-marketplace-business',
  DEFAULT: 'cgu-acheteurs-marketplace'
};

var buildCategoryUrl = (locale, slug, hash) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(CATEGORY_INFIX, "/").concat(slug, "-").concat(hash);

var buildProductUrl = (locale, slug, reference, offer) => {
  var url = "/".concat(locale.market, "/").concat(locale.language, "/").concat(PRODUCT_INFIX, "/").concat(slug, "-").concat(reference, ".htm");

  if (offer) {
    url = "".concat(url, "?offer=").concat(offer);
  }

  return url;
};

var buildCustomProductUrl = (locale, reference) => "/".concat(locale.market, "/").concat(locale.language, "/configurator/product/").concat(reference);

var buildStaticUrl = (locale, slug, oldVersion) => {
  if (oldVersion) {
    // handle WEB static pages url until they switch to nuxt
    return "/".concat(locale.market, "/").concat(locale.language, "/").concat(slug);
  }

  return "/".concat(locale.market, "/").concat(locale.language, "/").concat(STATIC_INFIX, "/").concat(slug);
};

var buildSearchUrl = (locale, query) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(SEARCH_INFIX, "/").concat(query);

var buildEditoUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/").concat(page);

var buildMyAccountUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/user");

var buildFaqUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/help/faq/").concat(page);

var buildContactFormUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/help/contact/").concat(page);

var buildReturnFormUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/help/return/").concat(page);

var buildCgvUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/legal/").concat(CgvType[page] || CgvType.DEFAULT);

var buildCguUrl = (locale, page) => "/".concat(locale.market, "/").concat(locale.language, "/").concat(EDITO_INFIX, "/legal/").concat(CguType[page] || CguType.DEFAULT);

var buildShippingUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/shipping");

var buildPaymentUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/payment");

var buildPaymentPaypalPendingUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/payment-paypal-pending");

var buildPaymentPaypalCanceledUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/payment-paypal-canceled");

var buildPaymentConfirmedUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/confirmed");

var buildPaymentRefusedUrl = locale => "/".concat(locale.market, "/").concat(locale.language, "/t/refused");

var buildMerchantUrl = (locale, reference) => "/".concat(locale.market, "/").concat(locale.language, "/m/").concat(reference);

var buildCartUrl = locale => USE_MERCURE(locale.iso) ? "/".concat(locale.market, "/").concat(locale.language, "/cart") : "/".concat(locale.market, "/").concat(locale.language, "/panier.html");

var buildLoginUrl = (locale, isTunnel) => isTunnel ? "/".concat(locale.market, "/").concat(locale.language, "/t/login") : "/".concat(locale.market, "/").concat(locale.language, "/login");

var buildSignupUrl = (locale, isTunnel) => isTunnel ? "/".concat(locale.market, "/").concat(locale.language, "/t/signup") : "/".concat(locale.market, "/").concat(locale.language, "/signup");

var buildGiftCardDownloadUrl = (locale, hashPdf) => "/".concat(locale.market, "/").concat(locale.language, "/user/gift-card-download?hashPdf=").concat(hashPdf);

export var urlBuilder = {
  buildCartUrl,
  buildCgvUrl,
  buildCguUrl,
  buildShippingUrl,
  buildHomeUrl,
  buildLoginUrl,
  buildMerchantUrl,
  buildMyAccountUrl,
  buildPaymentUrl,
  buildPaymentPaypalPendingUrl,
  buildPaymentPaypalCanceledUrl,
  buildPaymentConfirmedUrl,
  buildPaymentRefusedUrl,
  buildProductUrl,
  buildCustomProductUrl,
  buildSignupUrl
};
export default {
  methods: {
    buildHomeUrl,
    buildCartUrl,
    buildCategoryUrl,
    buildCustomProductUrl,
    buildContactFormUrl,
    buildEditoUrl,
    buildFaqUrl,
    buildGiftCardDownloadUrl,
    buildLoginUrl,
    buildMerchantUrl,
    buildProductUrl,
    buildReturnFormUrl,
    buildSearchUrl,
    buildStaticUrl
  }
};